import "./Taisyklės.css";

function Taisyklės() {
  return (
    <section
      id="taisykles"
      className="taisykles-section"
      style={{
        backgroundImage: `url(https://res.cloudinary.com/dvuaaubys/image/upload/v1764855160/5_nhntwk.jpg)`,
      }}
    >
      <div className="taisykles-container">
        <div className="title-center">
          <h2 className="kainorastis-title">Taisyklės</h2>
        </div>

        <div className="cards-row">
          <div className="price-card">
            <h3 className="rules-card-title">Registracija ir atšaukimas</h3>
            <ol className="taisykles-list">
              <li>
                <h4>Pranešimas apie neatvykimą</h4>
                <p>
                  Klientas privalo pranešti apie neatvykimą ar vėlavimą ne
                  vėliau kaip prieš 24 valandas iki sutarto laiko.
                </p>
              </li>

              <li>
                <h4>Nepranešus</h4>
                <p>
                  Jeigu klientas nepraneša per 24 val. ir neatvyksta, laikoma,
                  kad paslauga buvo rezervuota ir:
                </p>
                <ul className="taisykles-bullets">
                  <li>taikomas 100 % seanso mokestis;</li>
                  <li>
                    kitoms registracijoms gali būti taikomas tik išankstinis
                    depozitas arba atsisakyta registruoti.
                  </li>
                </ul>
              </li>

              <li>
                <h4>Išimtys</h4>
                <p>
                  Studija pasilieka veto teisę netaikyti mokesčio išskirtiniais
                  atvejais:
                </p>
                <ul className="taisykles-bullets">
                  <li>staigi liga;</li>
                  <li>avarija;</li>
                  <li>rimtos šeimos aplinkybės.</li>
                </ul>
                <p className="taisykles-note">
                  ⚠️ Veto teisė priklauso tik studijai, ne automatiškai
                  klientui.
                </p>
              </li>

              <li>
                <h4>Depozitas</h4>
                <p>
                  Vienkartiniams masažams taikomas depozitas – 20–30 € (arba
                  ~30–40 % kainos).
                </p>
                <ul className="taisykles-bullets">
                  <li>įskaičiuojamas į masažo kainą;</li>
                  <li>negrąžinamas, jei atšaukiama likus &lt; 24 val.;</li>
                  <li>perkeliamas tik 1 kartą, jei pranešta laiku.</li>
                </ul>
              </li>
            </ol>
          </div>

          <div className="price-card">
            <h3 className="rules-card-title">
              Dovanų kupono galiojimo taisyklės
            </h3>
            <ul className="taisykles-bullets">
              <li>
                Dovanų kuponas galioja iki datos, nurodytos kupono langelyje.
              </li>
              <li>
                Pasibaigus galiojimo terminui kuponas nebegalioja, pinigai
                negrąžinami.
              </li>
              <li>
                Kupono galiojimas gali būti pratęstas 1 kartą – 1 mėnesiui,
                sumokėjus 10 € pratęsimo mokestį.
              </li>
              <li>
                Vizitą su dovanų kuponu prašome rezervuoti iš anksto,
                rekomenduojama ne vėliau kaip 2–3 savaitės iki galiojimo
                pabaigos.
              </li>
              <li>
                Atšaukus ar perkėlus vizitą likus mažiau nei 24 val., dovanų
                kuponas laikomas panaudotu.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Taisyklės;
